/**
 * What a workflow page shows while the Analyst rail's code is on its way.
 * Its own file so a host page can import it without pulling the rail — and
 * the whole chat page behind it — into its bundle.
 */

import React from "react";

const RailFallback: React.FC = () => (
	<aside className="w-[440px] shrink-0 border-l border-gray-200 bg-white" />
);

export default RailFallback;
